import { render, staticRenderFns } from "./MiscBacklog.vue?vue&type=template&id=113dcd82"
import script from "./MiscBacklog.vue?vue&type=script&lang=js"
export * from "./MiscBacklog.vue?vue&type=script&lang=js"
import style0 from "./MiscBacklog.vue?vue&type=style&index=0&id=113dcd82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports